module.exports = __webpack_public_path__ + "icon_go_link_external.a469c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_go_link_external.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_go_link_external.svg
// module chunks = main